@let config = ACTION_CONFIG[status()];

<div class="display-flex justify-content-center flex-direction-column">
  @if (conversationStore.voiceUploadError(); as error) {
    <!-- TODO-VM: Use sb-form-box-error -->
    <div class="form-error mb-4 pf-4 color-red text-align-left">
      <div class="display-flex">
        <div class="mb-0 font-weight-500 flex-grow-1 mr-1">Voice not uploaded</div>
        <sb-icon
          class="cursor-pointer"
          [name]="'simple-remove'"
          [size]="'6'"
          (click)="conversationStore.clearVoiceUploadError()"
        />
      </div>
      @if (error.messages) {
        @for (message of error.messages; track $index) {
          <div class="mb-0">{{ message }}</div>
        }
      }
    </div>
  }

  <div class="mb-6 color-jet t-5@r mh-auto">
    {{ config.title }}
  </div>

  <button
    class="button-action mb-4 mh-auto align-items-center justify-content-center border-radius-circle"
    [ngClass]="
      (config.color.type === 'gradient' ? 'button-action--gradient-' : 'button-action--color-') + config.color.name
    "
    (click)="config.onAction()"
  >
    <sb-icon [name]="config.icon" [size]="'2'">
      <div
        class="mix-blend-mode-screen fill-parent"
        [ngClass]="(config.color.type === 'gradient' ? 'bg-gradient-' : 'bg-') + config.color.name"
      ></div>
    </sb-icon>
  </button>

  @if (voiceMessageRecorderStore.media()?.url || conversationStore.voice()?.url; as src) {
    <audio sbBlobPlayer [src]="src"></audio>
  }

  <div class="mb-6 t-9@r color-ash mh-auto">
    @switch (status()) {
      @case ('pristine') {
        Press to Record
      }

      @case ('recording') {
        @let recordingTime =
          voiceMessageRecorderStore.maxDurationMs() - (voiceMessageRecorderStore.recordingEndsAt() | expiryTimer)!;
        {{ recordingTime | date: 'm:ss' }} /
        {{ voiceMessageRecorderStore.maxDurationMs() | date: 'm:ss' }}
      }

      @case ('uploaded') {
        Ready to Send -
        {{ player()!.duration() | date: 'm:ss' }}
      }

      @default {
        {{ player()!.currentTime() | date: 'm:ss' }} -
        {{ player()!.duration() | date: 'm:ss' }}
      }
    }
  </div>

  <div class="display-flex">
    @if (conversationStore.voice()) {
      <button
        class="mr-4"
        sbButton
        [iconOnly]="true"
        [shadow]="'default-sm'"
        [size]="'big'"
        [variant]="'fill-light'"
        (click)="voiceMessageRecorderStore.deleteVoice()"
      >
        <sb-icon class="color-iron" [name]="'trash-can'" [size]="'5'" />
      </button>

      @if (memberService.account.benefactor) {
        <sb-field-boost
          class="display-flex mr-4"
          [ngModel]="voiceMessageRecorderStore.boosted()"
          [wrapped]="true"
          (change)="voiceMessageRecorderStore.toggleBoost()"
        />
      }
    }

    <button
      class="flex-grow-1"
      sbButton
      [disabled]="!conversationStore.voice()"
      [processing]="conversationStore.voiceUploadInProgress()"
      [size]="'big'"
      [stretchable]="true"
      [variant]="'fill-blue'"
      (click)="attemptToSendMessage()"
    >
      <sb-icon class="mr-1" [name]="'send'" />
      <span class="font-weight-500">Send</span>
    </button>
  </div>
</div>
